export enum SocialMediaPlatforms {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  VKontakte = 'vkontakte',
  Wechat = 'wechat',
}
